module.exports = __webpack_public_path__ + "img/Logo-29.8500fb11.svg";